var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "save-tray-block container my-5",
      attrs: { id: "saveTrayModal" }
    },
    [
      _c("h5", { staticClass: "save-tray-header text-center" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$resourceString["virtualtray.Savetray.Header"]) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _vm.trayId && !_vm.isAdminMode && _vm.boardDetails.role == 0
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 d-flex mt-2" }, [
              _c("p", { staticClass: "font-16 mt-2 pl-2" }, [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$resourceString["common.Label.Note"]) + ": "
                  )
                ]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$resourceString["virtualtray.Savetray.CopyTrayNote"]
                    ) +
                    "\n      "
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "wf-modal-button-close btn button-full",
          attrs: { type: "button" },
          on: {
            click: function() {
              _vm.hideModal("save-tray")
              _vm.handleCroppedImgData()
            }
          }
        },
        [
          _c("span", {
            staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
            attrs: { "aria-label": "Close modal" }
          })
        ]
      ),
      _vm._v(" "),
      !_vm.trayId && _vm.isAdminMode
        ? _c("div", [
            _c("h5", {}, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$resourceString["virtualtray.Savetray.Type.Header"]
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex pb-4" }, [
              _c(
                "label",
                {
                  staticClass:
                    "border flex-grow-1 custom-control custom-radio mr-4 pl-4 rounded",
                  attrs: { for: "radio-personal" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedOption,
                        expression: "selectedOption"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "radio-personal",
                      type: "radio",
                      value: "virtualTray"
                    },
                    domProps: {
                      checked: _vm._q(_vm.selectedOption, "virtualTray")
                    },
                    on: {
                      change: function($event) {
                        _vm.selectedOption = "virtualTray"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-control-label" }, [
                    _c("div", { staticClass: "text-size-small font-24" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$resourceString[
                              "virtualtray.Savetray.PersonalTray.Header"
                            ]
                          ) +
                          "\n          "
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass:
                    "border flex-grow-1 custom-control custom-radio pl-4 rounded",
                  attrs: { for: "radio-brand" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedOption,
                        expression: "selectedOption"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "radio-brand",
                      type: "radio",
                      value: "premixTray"
                    },
                    domProps: {
                      checked: _vm._q(_vm.selectedOption, "premixTray")
                    },
                    on: {
                      change: function($event) {
                        _vm.selectedOption = "premixTray"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-control-label" }, [
                    _c("div", { staticClass: "text-size-small font-24" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$resourceString[
                              "virtualtray.Savetray.BrandTray.Header"
                            ]
                          ) +
                          "\n          "
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "position-relative" }, [
        _c(
          "label",
          {
            staticClass: "modal-content border-0",
            attrs: { for: "tray-cover-input" }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$resourceString["virtualtray.Savetray.TrayCover.Label"]
                ) +
                "\n\n      "
            ),
            _c("div", { staticClass: "tray-cover position-relative" }, [
              _c("input", {
                ref: "fileInput",
                attrs: {
                  id: "tray-cover-input",
                  type: "file",
                  accept: "image/x-png,image/png,image/jpeg"
                },
                on: { change: _vm.handleFileUpload }
              }),
              _vm._v(" "),
              !_vm.getCropeedImg
                ? _c("span", { staticClass: "btn btn-outline-primary" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$resourceString[
                            "virtualtray.Savetray.UploadImage.Button"
                          ]
                        ) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              ((_vm.trayId &&
                !_vm.getselectAnotherImage &&
                (!_vm.getIsstartOverOrCancel || _vm.selectedFileUrlForEdit)) ||
                !_vm.getIsstartOverOrCancel) &&
              _vm.selectedFileUrl &&
              _vm.getCropeedImg
                ? _c("img", {
                    staticClass: "h-100",
                    attrs: { src: _vm.getCropeedImg, alt: _vm.trayName || "" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.getCropeedImg && _vm.selectedFileUrl
                ? _c("div", { staticClass: "on-hover-background-card" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-outline-white-warn btn btn-outline-primary",
                        attrs: { rel: "noopener" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$resourceString[
                              "virtualtray.Savetray.UploadAnotherImage.Button"
                            ]
                          )
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _vm.trayImageUploadError
          ? _c("p", { staticClass: "text-danger font-16" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$resourceString["virtualtray.Savetray.Validitaion"]
                  ) +
                  "\n    "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "my-5" }, [
        _c("label", { attrs: { for: "tray_name" } }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$resourceString["virtualtray.Savetray.TrayName.Label"]
              ) +
              "*\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: " mb-4" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.trayName,
                expression: "trayName"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              id: "tray_name",
              placeholder: "Enter tray name",
              "aria-describedby": "basic-addon3"
            },
            domProps: { value: _vm.trayName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.trayName = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.trayNameError
            ? _c("p", { staticClass: "text-danger font-16" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$resourceString["virtualtray.Savetray.TrayName.Error"]
                    ) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "tray-description" } }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$resourceString[
                  "virtualtray.Savetray.TrayDescription.Label"
                ]
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.trayDescription,
                expression: "trayDescription"
              }
            ],
            staticClass: "form-control",
            attrs: {
              id: "tray-description",
              "aria-label": "With textarea",
              placeholder: "Describe your tray..."
            },
            domProps: { value: _vm.trayDescription },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.trayDescription = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "my-4 d-flex justify-content-end" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-primary mx-2",
              on: {
                click: function() {
                  _vm.hideModal("save-tray")
                  _vm.handleCroppedImgData()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$resourceString["virtualtray.Savetray.Cancel.Button"]
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("a", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { disabled: this.saveTrayDisabled },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.saveTrayItem($event)
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$resourceString["virtualtray.Savetray.Save.Button"]
                    ) +
                    "\n        "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }